import { Injectable } from '@angular/core';
import { AppSettings, defaults } from '@shared/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private options = defaults;

  get notify(): Observable<any> {
    return this.notify$.asObservable();
  }

  private notify$ = new BehaviorSubject<any>({});
  public theme: string = defaults.theme;

  setOptions(options: AppSettings) {
    this.options = Object.assign(defaults, options);
    this.theme = options.theme;
    this.notify$.next(this.options);
  }

  getOptions(): AppSettings {
    return this.options;
  }

  setTheme(theme: string): void {
    this.theme = theme;
  }

  /** System language */

  get language() {
    return this.options.language;
  }

  setLanguage(lang: string) {
    this.options.language = lang;
    this.notify$.next({ lang });
  }
}
